import type { Farming } from '@/interfaces/farming.interface'
import { HttpMethod, Performer } from '../core'

export class StartFarming extends Performer<
  void,
  {
    status: 'failed' | 'success'
    farming: Farming
  }
> {
  protected method = HttpMethod.POST
  protected url = '/start-farming'
}
